import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Auth } from '../layout/Auth';
import {
  requestForgot,
  requestNewPassword,
} from '../../store/actions/user';
import { goToLogin } from '../../helpers/location';
import { ResetPasswordSchema } from '../../helpers/schemas';
import { ForgotLinks } from '../../components/layout/Auth/ForgotLinks';
import { NewPasswordForm } from '../../components/pages/auth/NewPasswordForm';
import './NewPassword.scss';

function NewPasswordComponent(props) {
  let { token } = props.match.params;

  const { requestNewPassword } = props;

  return (
    <div className="new-password-page">
      <Auth title={<FormattedMessage
        id="app.forgot_password.forgot_password_page_title"/>}
            lead={<FormattedMessage
              id="app.forgot_password.forgot_password_page_description"/>}>
        <NewPasswordForm
          onSubmit={
            values => requestNewPassword(
              values.password,
              values.password_confirmation,
              values.token
            )
          }
          schema={ResetPasswordSchema}
          initialValues={
            {
              password: '',
              password_confirmation: '',
              token: token
            }
          }
          token={token}
          btnId="app.forgot.reset_btn"
        />
      </Auth>
      <div className="new-password-page__links">
        <ForgotLinks logInLink={props.goToLogin}/>
      </div>
    </div>
  );
}

NewPasswordComponent.defaultProps = {
  goToLogin,
};

const mapActionsToProps = {
  requestNewPassword,
  requestForgot,
};

const NewPassword = connect( null, mapActionsToProps )( NewPasswordComponent );

export { NewPassword, NewPasswordComponent };
